import { useMemo } from "react"
import { useForm } from "react-hook-form"

import { useEvent } from "shared/lib/useEvent"
import { useFormSubmit } from "shared/lib/useFormSubmit"

import { useDuplicationAffix } from "entities/projects/model/useDuplicationAffix"

import { DuplicateProjectOverlayViewModel } from "../DuplicateProjectOverlayView"

export function useDuplicateProjectOverlay({
  project,
  autoFocus = true,
  onDuplicate,
  onClose
}: DuplicateProjectOverlayViewModel) {
  const { addSuffix } = useDuplicationAffix()

  const form = useForm({
    defaultValues: { title: addSuffix(project?.title ?? "") }
  })

  const submitDuplicate = useEvent(async ({ title }: { title?: string }) => {
    if (!title || !project) {
      return { data: null, errors: [{ message: "invalid" }] }
    }
    try {
      const result = await onDuplicate({ projectID: project.id, title })
      return { data: result ?? null }
    } catch (error) {
      return { data: null, errors: [{ message: String(error) }] }
    }
  })

  const { handleSubmit: handleFormSubmit, isSubmitting } = useFormSubmit({
    onSubmit: submitDuplicate,
    onSuccess: onClose
  })

  const handleSubmit = useMemo(
    () => form.handleSubmit(handleFormSubmit),
    [form.handleSubmit, handleFormSubmit]
  )

  return {
    form,
    autoFocus,
    isSubmitting,
    onSubmit: handleSubmit,
    onCancel: onClose
  }
}
